const initializedSections = new WeakSet();

const getSections = (scope) => {
  if (!scope?.querySelectorAll) {
    return [];
  }

  if (scope.matches?.('.trustpilot-reviews-sec')) {
    return [scope];
  }

  return Array.from(scope.querySelectorAll('.trustpilot-reviews-sec'));
};

const revealSection = (section) => {
  section.classList.add('is-visible');
};

export function initTrustpilotReviews(scope = document) {
  getSections(scope).forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    initializedSections.add(section);

    const bg = section.querySelector('.trustpilot-reviews-sec__bg');
    const backgroundLayer = section.parentElement?.querySelector(
      '[data-trustpilot-reviews-bg]'
    );

    if (backgroundLayer) {
      const container = section.parentElement;
      let frame = null;

      const updateBackgroundLayer = () => {
        if (frame !== null) {
          return;
        }

        frame = window.requestAnimationFrame(() => {
          frame = null;
          backgroundLayer.style.setProperty(
            '--trustpilot-reviews-bg-top',
            `${section.offsetTop}px`
          );
          backgroundLayer.style.setProperty(
            '--trustpilot-reviews-bg-height',
            `${section.offsetHeight}px`
          );
        });
      };

      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(updateBackgroundLayer);
        resizeObserver.observe(container);
        resizeObserver.observe(section);
      } else {
        window.addEventListener('resize', updateBackgroundLayer, {
          passive: true,
        });
      }

      updateBackgroundLayer();
    }

    if (!bg || typeof IntersectionObserver === 'undefined') {
      revealSection(section);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          revealSection(section);
          observer.unobserve(section);
        });
      },
      {
        rootMargin: '0px 0px -18% 0px',
        threshold: 0.2,
      }
    );

    observer.observe(section);
  });
}

globalThis.initTrustpilotReviews = initTrustpilotReviews;

if (typeof document !== 'undefined' && !document.querySelector('.bold-loader-new')) {
  initTrustpilotReviews();
}
